export function washData_scrollText(walkedNode) {

  walkedNode.actions = [
    "attribute",
    {
      "name": "design",
      "config": {
        "分组1": [
          "self_background",
          "title_textTheme",
          "title_fontFamily",
          "title_fontSize",

          "scrollTextunit_fontSize",
          'title_gapOfListV2',
          'title_flexVerticalAlign',


          "title_color",
          "title_textStyle",
          "title_textAlign",
          "title_lineHeight",
          "title_letterSpace",
          "self_margin",
          "self_padding",
          "self_zIndex"
        ]
      }
    },
    "hover",
    "style",
    "store",
    "translate",
    "isShow"
  ]

  if(walkedNode.data.design?.title_fontSize){
    walkedNode.data.design.scrollTextvalue_fontSize = walkedNode.data.design.title_fontSize
    walkedNode.data.design.scrollTextvalue_fontSizeUnit = walkedNode.data.design.title_fontSizeUnit
  }



}
